import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Paginated, PublicacaoVendaApi } from './catalog-api.model';

export type CatalogoVendaQuery = Record<string, string | number | boolean | undefined | null>;

/**
 * Cliente do catálogo de venda (`/catalogo/venda`). Não inclui aluguel — use `CatalogoAluguelService` para isso.
 */
@Injectable({ providedIn: 'root' })
export class CatalogoVendaService {
  private readonly base = environment.apiBaseUrl;

  constructor(private readonly http: HttpClient) {}

  /** Lista apenas publicações de venda (seminovos/novos anunciados para compra). */
  listar(q?: CatalogoVendaQuery): Observable<Paginated<PublicacaoVendaApi>> {
    let params = new HttpParams();
    if (q) {
      for (const [k, v] of Object.entries(q)) {
        if (v !== undefined && v !== null && v !== '') {
          params = params.set(k, String(v));
        }
      }
    }
    return this.http.get<Paginated<PublicacaoVendaApi>>(`${this.base}/catalogo/venda`, { params });
  }

  /** Detalhe de um anúncio de venda. */
  detalhe(id: number): Observable<PublicacaoVendaApi> {
    return this.http.get<unknown>(`${this.base}/catalogo/venda/${id}`).pipe(
      map((raw) => this.unwrapSingleResource<PublicacaoVendaApi>(raw)),
    );
  }

  private unwrapSingleResource<T>(raw: unknown): T {
    if (raw && typeof raw === 'object' && 'data' in raw) {
      return (raw as { data: T }).data;
    }
    return raw as T;
  }
}
